export default __webpack_public_path__ + "static/figure1-895f01881900708549862c152f946c8d.webp";